import { StepClass } from '../common';
import { generateUUID } from '../utils/generateUUID';
import { STEP_PREFIXES } from './constants';
import { YesOrNoStepType } from './types';
export function create(partial = {}) {
    return Object.assign({ uuid: generateUUID(STEP_PREFIXES[StepClass.YesOrNo]), className: StepClass.YesOrNo, title: null, description: [], isRequired: false, revision: 0, type: YesOrNoStepType.YesNo, conditions: {
            answer: {
                true: null,
                false: null,
            },
            ALWAYS: null,
        } }, partial);
}
export function setConditionalRule(mutable, answer, selectedStepUUID) {
    // TODO: handle the ALWAYS condition
    if (mutable.conditions) {
        if (answer) {
            mutable.conditions.answer.true = selectedStepUUID;
        }
        else {
            mutable.conditions.answer.false = selectedStepUUID;
        }
    }
    // support for documents that don't have this conditions object yet
    else {
        mutable.conditions = {
            answer: {
                true: answer ? selectedStepUUID : null,
                false: answer ? null : selectedStepUUID,
            },
            ALWAYS: null,
        };
    }
}
export function setAlwaysConditionalRule(mutable, selectedStepUUID) {
    if (mutable.conditions) {
        mutable.conditions.ALWAYS = selectedStepUUID;
    }
    else {
        mutable.conditions = {
            answer: {
                true: null,
                false: null,
            },
            ALWAYS: selectedStepUUID,
        };
    }
}
export function deleteConditionalRule(mutable, answer) {
    if (mutable.conditions) {
        if (answer) {
            mutable.conditions.answer.true = null;
        }
        else {
            mutable.conditions.answer.false = null;
        }
    }
}
export function deleteAlwaysConditionalRule(mutable) {
    if (mutable.conditions) {
        mutable.conditions.ALWAYS = null;
    }
    else {
        mutable.conditions = {
            answer: {
                true: null,
                false: null,
            },
            ALWAYS: null,
        };
    }
}
export function getConditionalNextStepUUID(step, answer) {
    let destinationStep = null;
    if (step.conditions) {
        // lookup any saved rules in the document
        if (answer === true) {
            destinationStep = step.conditions.answer.true;
        }
        else if (answer === false) {
            destinationStep = step.conditions.answer.false;
        }
        // if no set rules, check the always rule
        if (!destinationStep) {
            destinationStep = step.conditions.ALWAYS;
        }
    }
    return destinationStep;
}
